<template>
  <div class="content">
    <h5-header :header-msg="headerMsg"></h5-header>
    <div class="order_msg">
      <div>
        <p>
          <span>金额</span>
          <span>￥{{ordersObj.money}}</span>
        </p>
        <p>
          <span>订单号</span>
          <span>{{ordersObj.orderSn}}</span>
        </p>
        <p>
          <span></span>
          <span>{{ordersObj.createTime}}</span>
        </p>
      </div>
    </div>

    <p class="bgcolor"></p>

    <div class="lists">
      <p>购买的商品</p>

      <div class='li' v-for='(item,index) in ordersObj.list' :key='index' >
          <span>{{item.name}}</span> 
          <!-- <span >约{{parseInt(item.weight*100)/100}}克/份</span>  -->
          <span>买(</span><span v-show='item.realCount*100>0 && item.unitFlag == 0'>{{parseInt(item.realCount*100)/100}}份</span>
          <span v-show='item.catty*100>0 && item.unitFlag == 1'>{{item.catty}}斤</span> 
          <span v-show='item.ounce*100>0 && item.unitFlag == 1'>{{parseInt(item.ounce*100)/100}}两</span><span>)</span>
          <span>{{item.singleTotalPrice}}元</span>
      </div>
    </div>
    
  </div>
</template>

<script>
import { orderDetail } from "@/api/picker/index";
export default {
  data() {
    return {
      show: false,
      headerMsg: {
        title: "采购金详情",
        url: "/includeDetail"
      },
      page: 1,
      ordersObj: {},
      ordersObjs: {}
    };
  },
  mounted() {
    this.orderDetail();
    console.log(this.$route.query);
    this.ordersObjs = this.$route.query.item;
    // this.headerMsg.url = this.$store.getters.url
  },
  methods: {
    orderDetail() {
      let obj = {
        token: this.$store.getters.token || this.GetQueryString("token"),
        orderId: this.$route.query.item.orderId // 订单ID
      };
      orderDetail(obj).then(res => {
        this.ordersObjs.list = res.content.list;
        this.ordersObj = this.ordersObjs
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  p {
    margin: 0;
  }
  .order_msg {
    width: 375px;
    height: 117px;
    // margin: 44px 0 0 0;
    background: rgba(255, 255, 255, 1);
    display: flex;
    div {
      width: fit-content;
      height: 100%;
      p {
        width: 100%;
        height: 34px;
        margin: 0;
        display: flex;
        align-items: center;
        span {
          display: block;
          color: #1d1d1d;
        }
        span:first-child {
          width: 65px;
          height: 21px;
          margin-right: 15px;
          margin-left: 15px;
          font-size: 15px;
          color: #1d1d1d;
          text-align: left;
        }
        span:last-child {
          font-size: 15px;
        }
      }
      p:first-child {
        margin-top: 10px;
        span:last-child {
          color: #ec130c;
          font-weight: bold;
        }
      }
      p:last-child {
        span {
          color: #666666;
          margin-left: -32px;
          font-size: 14px;
        }
      }
    }
  }
  .bgcolor {
    width: 100%;
    height: 10px;
    background: #f5f5f5;
    margin: 0;
  }
  .lists {
    width: auto;
    height: 100%;
    padding: 15px;
    > p {
      color: #1d1d1d;
      font-weight: bold;
      font-size: 18px;
      text-align: left;
    }
    .li{
        width: 100%;
        height: 46px;
        border-bottom: 1px solid #E4E4E4;
        text-align: left;
        display: flex;
        align-items: center;
        span{
            font-size: 15px;
            
        }
        span:nth-child(2){
            margin: 0  0 0 10px;
        }
        span:last-child{
            margin-left: auto;
        }
    }
  }
}
</style>

